import React, { Component } from 'react';

class Apartments extends Component {
    render() {
        return (
            <div>
       
        {/*::breadcrumb part start::*/}
        <section className="breadcrumb blog_bg">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="breadcrumb_iner">
                  <div className="breadcrumb_iner_item">
                    <h2>Apartment</h2>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/*::breadcrumb part start::*/}
        {/*::project_gallery details start::*/}
        <section className="gallery_details mt-5">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="project_img">
                  <img src="img/gallery/gallery_4.png" alt="" />
                  <div className="project_gallery_hover_text">
                    <p>Home Apartment</p>
                    <h3>Detached House For Sale </h3>
                    <ul>
                      <li><a href="#"><span className="flaticon-bath" /></a> 04</li>
                      <li><a href="#"><span className="flaticon-bed" /></a> 03</li>
                      <li><a href="#"><span className="flaticon-frame" /></a> 2400 sqft</li>
                      <li><a href="#"><span className="ti-heart" /></a> like</li>
                    </ul>
                  </div>
                  <p>Justo curabitur metus sit ac suspendisse ad Fringilla diam sem. Tellus,
                    purus dolor praesent, vitae ac est natoque nibh primis quam parturient 
                    facilisis viverra netus magna et cursus ornare, sit. Donec nisl dignissim 
                    lobortis senectus dictum nullam mi et  auctor lectus nisi.</p>
                  <p>Tempor tellus. Tristique class morbi dapibus habitasse eget eget varius 
                    curabitur lacinia curae; maecenas feugiat molestie odio vivamus mollis
                    tincidunt dictumst donec nam semper lacinia platea bibendum ligula vel ante.</p>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/*::project_gallery details start::*/}
        {/*::footer_part start::*/}
        <footer className="footer_part">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="footer_logo">
                  <a href="index.html" className="footer_logo_iner"> <img src="img/footer_logo.png" alt="#" /> </a>
                </div>
              </div>
              <div className="col-sm-6 col-lg-3">
                <div className="single_footer_part">
                  <h4>About Us</h4>
                  <p>Heaven fruitful doesn't over lesser days appear creeping seasons so behold bearing days open</p>
                  <div className="footer_icon social_icon">
                    <ul className="list-unstyled">
                      <li><a href="#" className="single_social_icon"><i className="fab fa-facebook-f" /></a></li>
                      <li><a href="#" className="single_social_icon"><i className="fab fa-twitter" /></a></li>
                      <li><a href="#" className="single_social_icon"><i className="fas fa-globe" /></a></li>
                      <li><a href="#" className="single_social_icon"><i className="fab fa-behance" /></a></li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="col-sm-6 col-lg-3">
                <div className="single_footer_part">
                  <h4>Contact Info</h4>
                  <p>Address : Your address goes
                    here, your demo address.</p>
                  <p>Phone : +8880 44338899</p>
                  <p>Email : info@colorlib.com</p>
                </div>
              </div>
              <div className="col-sm-6 col-lg-3">
                <div className="single_footer_part">
                  <h4>Important Link</h4>
                  <ul className="list-unstyled">
                    <li><a href="#"> WHMCS-bridge</a></li>
                    <li><a href="#">Search Domain</a></li>
                    <li><a href="#">My Account</a></li>
                    <li><a href="#">Shopping Cart</a></li>
                    <li><a href="#">Our Shop</a></li>
                  </ul>
                </div>
              </div>
              <div className="col-sm-6 col-lg-3">
                <div className="single_footer_part">
                  <h4>Newsletter</h4>
                  <p>Heaven fruitful doesn't over lesser in days. Appear creeping seasons deve behold bearing days open
                  </p>
                  <div id="mc_embed_signup">
                    <form target="_blank" action="https://spondonit.us12.list-manage.com/subscribe/post?u=1462626880ade1ac87bd9c93a&id=92a4423d01" method="get" className="subscribe_form relative mail_part" required>
                      <input type="email" name="email" id="newsletter-form-email" placeholder="Email Address" className="placeholder hide-on-focus"     required />
                      <button type="submit" name="submit" id="newsletter-submit" className="email_icon newsletter-submit button-contactForm"><i className="far fa-paper-plane" /></button>
                      <div className="mt-10 info" />
                    </form>
                  </div>
                </div>
              </div>
            </div>
            <hr />
            <div className="row">
              <div className="col-lg-12">
                <div className="copyright_text text-center">
                  <p>{/* Link back to Colorlib can't be removed. Template is licensed under CC BY 3.0. */}
                    Copyright © All rights reserved | This template is made with <i className="fa fa-heart" aria-hidden="true" /> by <a href="https://colorlib.com" target="_blank">Colorlib</a>
                    {/* Link back to Colorlib can't be removed. Template is licensed under CC BY 3.0. */}</p>
                </div>
              </div>
            </div>
          </div>
        </footer>
        {/*::footer_part end::*/}
      </div>
        );
    }
}

export default Apartments;